module.exports = new __parcel__URL__("accounts.8b3d647a.png").toString();